var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteFriends(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0834 16.625V11.625M12.5834 14.125H17.5834M9.25008 11.625H5.91675C4.36361 11.625 3.58704 11.625 2.97447 11.8787C2.15771 12.217 1.5088 12.866 1.17048 13.6827C0.916748 14.2953 0.916748 15.0719 0.916748 16.625M12.1667 1.8673C13.3883 2.36179 14.2501 3.55943 14.2501 4.95833C14.2501 6.35724 13.3883 7.55488 12.1667 8.04937M10.5001 4.95833C10.5001 6.79928 9.0077 8.29167 7.16675 8.29167C5.3258 8.29167 3.83341 6.79928 3.83341 4.95833C3.83341 3.11738 5.3258 1.625 7.16675 1.625C9.0077 1.625 10.5001 3.11738 10.5001 4.95833Z",
    stroke: "#C4F538",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteFriends);
export default __webpack_public_path__ + "static/media/invite-friends.3b31453d9a6120ae71789756d90b7631.svg";
export { ForwardRef as ReactComponent };